import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import default_theme from 'assets/themes/themes';

const SignUpPromptOverlay = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleSignUpWithEmail = () => {
    navigate('/register');
    onClose();
  };

  const handleSignIn = () => {
    navigate('/login');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h5" component="div" sx={{ fontWeight: 600, textAlign: 'center' }}>
          Sign up to create a new project
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
          You need an account to create and manage projects. Continue with your email address to get started.
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button
            variant="outlined"
            fullWidth
            startIcon={<EmailIcon />}
            sx={{
              textTransform: "none",
              py: 1.5,
              color: "#2E7D32",
              borderColor: "#2E7D32",
              "&:hover": {
                borderColor: "#1B5E20",
                backgroundColor: "rgba(46, 125, 50, 0.08)",
              },
            }}
            onClick={handleSignUpWithEmail}
          >
            Sign up with email
          </Button>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: 'center', py: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Already have an account?{' '}
          <Button
            variant="text"
            onClick={handleSignIn}
            sx={{
              textTransform: 'none',
              p: 0,
              minWidth: 'auto',
              textDecoration: 'underline',
              color: default_theme.palette.other.main,
              '&:hover': {
                textDecoration: 'underline',
                backgroundColor: 'transparent',
                color: default_theme.palette.other.tealDark,
              },
            }}
          >
            Sign in
          </Button>
        </Typography>
      </DialogActions>
    </Dialog>
  );
};

export default SignUpPromptOverlay;
